import { useState } from 'react';

const MAX_INPUT_LENGTH = 30;
const MAX_SELECTION_LENGTH = 20;

export const useSelectWithCreateHook = <T = string>({
    onChangeCallback,
}: {
    onChangeCallback?: (value: ISelectOption<T>[]) => void;
}) => {
    const [inputValue, setInputValue] = useState<string>('');

    const onInputChange = (value: string) => {
        if (value.length < MAX_INPUT_LENGTH) {
            setInputValue(value);
        }
    };

    const onChange = (value: any) => {
        if (value && onChangeCallback) {
            if (value.length > MAX_SELECTION_LENGTH) return;
            onChangeCallback(value);
        }
    };

    return { inputValue, onInputChange, onChange };
};
